import { render } from "./DeleteUser.vue?vue&type=template&id=49f6d9e9"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"
script.render = render

export default script